import * as React from 'react';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { AuthUser } from 'Core/models/AuthUser.js';
import ConfigUtility from 'Core/ConfigUtility';


export default class TokenUtility {
  public static GetUMAToken() {
    // Get cookie if it exist, if not
    // assume token is not required
    let Config = ConfigUtility.getSync()!;

    let koppTokenString = Cookies.get(Config.KoppTokenCookieName);

    if (!koppTokenString) {
      return undefined;
    }

    let koppToken = jwtDecode(koppTokenString) as any;
    return koppToken[Config.TokenPropertyKeys.UMATokenName];
  }

  public static GetUserFromCookies() {
    // Get cookie if it exist, if not
    // assume token is not required
    let Config = ConfigUtility.getSync()!;
    let koppTokenString = Cookies.get(Config?.KoppTokenCookieName || "notthere");

    if (!koppTokenString) {
      return undefined;
    }

    let koppToken = jwtDecode(koppTokenString) as any;

    if (!koppToken) {
      return undefined;
    }

    let user: AuthUser = {};
    user.username = koppToken[Config.TokenPropertyKeys.UserName];
    user.id = koppToken[Config.TokenPropertyKeys.Id];
    user.email = koppToken[Config.TokenPropertyKeys.EmailAddress];
    user.expirationTime = moment.unix(koppToken[Config.TokenPropertyKeys.expirationTime]);
    user.firstname = koppToken[Config.TokenPropertyKeys.FirstName];
    user.lastname = koppToken[Config.TokenPropertyKeys.LastName];
    //user.operations = koppToken[Config.TokenPropertyKeys.];
    user.sessionId = koppToken[Config.TokenPropertyKeys.SessionId];
    user.umaid = koppToken[Config.TokenPropertyKeys.UMATokenName];
    user.customerCode = koppToken[Config.TokenPropertyKeys.CustomerCode];
    user.mobilePhone = koppToken[Config.TokenPropertyKeys.MobilePhone];
    user.umaExpirationTime =
      koppToken[Config.TokenPropertyKeys.UMATokenExpirationName] &&
      moment.unix(koppToken[Config.TokenPropertyKeys.UMATokenExpirationName]);
    user.roles = koppToken[Config.TokenPropertyKeys.Roles];
    user.operations = koppToken[Config.TokenPropertyKeys.Operations];

    return user;
  }

  public static GetUMATokenExpirationDate(config?: typeof Config) {
    // Get cookie if it exist, if not
    // assume token is not required
    let Config = ConfigUtility.getSync()!;
    config = config ? config : Config;
    let koppTokenString = Cookies.get(config?.KoppTokenCookieName || "nontthere");

    if (!koppTokenString) {
      return null;
    }

    let koppToken = jwtDecode(koppTokenString) as any;
    var expirationDateUnixString = koppToken[Config?.TokenPropertyKeys.UMATokenExpirationName];
    var expirationDate = moment.unix(expirationDateUnixString);
    return expirationDate;
  }


  public static GetSessionId(config?: typeof Config) {
    // Get cookie if it exist, if not
    // assume token is not required
    let Config = ConfigUtility.getSync()!;
    config = config ? config : Config;
    let koppTokenString = Cookies.get(config?.KoppTokenCookieName || "nontthere");

    if (!koppTokenString) {
      return Date.now().toString();
    }

    let koppToken = jwtDecode(koppTokenString) as any;
    var sessionId = koppToken[Config?.TokenPropertyKeys.SessionId];
    return sessionId;
  }
}
